import { render, staticRenderFns } from "./NavCustom.vue?vue&type=template&id=5df8bf6c&scoped=true&"
import script from "./NavCustom.vue?vue&type=script&lang=js&"
export * from "./NavCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df8bf6c",
  null
  
)

export default component.exports